<template>
    <div>
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                title="Neuen Sitetype anlegen"
                :ok-disabled="!validate"
                @ok="submit" :loading="loading"
                @cancel="close"
        >
            <form>
                <div class="mx-2">
                    <Input v-model="sitetype_name" label="Sitetype - Bezeichnung"
                           :error-messages="sitetypeErrors" :required="true"
                           @input="$v.sitetype_name.$touch()"
                           @blur="$v.sitetype_name.$touch()"
                    ></Input>
                    <Input v-model="hash" label="Hash"
                           :error-messages="hashErrors" :required="true"
                           @input="$v.hash.$touch()"
                           @blur="$v.hash.$touch()"
                    ></Input>
                    <Dropdown v-model="selected_type" :items="device_types" label="Device Type"
                              :error-messages="typeErrors"
                              @input="$v.selected_type.$touch()"
                              @blur="$v.selected_type.$touch()"
                    ></Dropdown>
                </div>
            </form>
        </Dialog>
        <Snackbar v-model="successSnackbar" color="success">Sitetype erfolgreich angelegt.</Snackbar>
    </div>
</template>

<script>
import Input from "../../../components/Inputs/Input";
import Dropdown from "../../../components/Inputs/Dropdown";
import ada from "../../../scss/ada_colors.scss"
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import Snackbar from "../../../components/Snackbar";
import Utils from "../../../scripts/Utils";
import Dialog from "../../../components/Dialog";

export default {
    name: "AddSitetypeDialog",
    props: ['value'],
    mixins: [validationMixin],
    validations: {
        hash: {required},
        sitetype_name: {required},
        selected_type: {required},
    },
    components: {Dialog, Snackbar, Dropdown, Input},
    data: () => {
        return {
            sitetype_name: null,
            hash: null,
            selected_type: null,
            device_types: [
                {text: 'App', value: 'app'},
                {text: 'Mobile', value: 'mobile'},
                {text: 'Desktop', value: 'desktop'}
            ],
            successSnackbar: false,
            loading: false,
            ada,
        }
    },
    computed: {
        vuexState() {
            return this.$store.state.display;
        },
        sitetypeErrors() {
            return Utils.handleError(this, 'sitetype_name', 'Sitetype ist erforderlich.');
        },
        hashErrors() {
            return Utils.handleError(this, 'hash', 'Hash ist erforderlich.');
        },
        typeErrors() {
            return Utils.handleError(this, 'selected_type', 'Device Type ist erforderlich.');
        },
        validate() {
            return this.sitetypeErrors.length === 0 &&
                this.hashErrors.length === 0 &&
                this.typeErrors.length === 0;
        }
    },
    methods: {
        update(value) {
            this.$emit('input', value);
        },
        async submit() {
            this.$v.$touch();
            if (this.validate) {
                this.loading = true;
                let data = await this.$store.dispatch('display/createSitetype', this.getBody());
                this.loading = false;
                if (data.Status) {
                    this.successSnackbar = true;
                    this.close();
                }
            }
        },
        getBody() {
            return {
                site_id: this.$route.name === 'settings' ? this.$store.state.settings.selectedItem.SiteId : this.vuexState.selectedSite.SiteId,
                Name: this.sitetype_name,
                Hash: this.hash,
                Type: this.selected_type.value,
            }
        },
        reset() {
            this.sitetype_name = null;
            this.hash = null;
            this.selected_type = null;
            this.$v.$reset();
        },
        close() {
            this.reset();
            this.$emit('input', false); // set v-model to false -> close dialog
        }
    }

}
</script>

<style scoped>

</style>